"use client";

const LOG_TAG = "🚫 app/not-found";
const DEBUG = false;

import Link from "@/components/MyLink";

export default function NotFound() {
  if (DEBUG) console.debug(LOG_TAG, "NotFound page rendered");

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      <div className="text-center px-4">
        <div className="mb-8 relative">
          {/* Musical note animation container */}
          <div className="absolute -top-16 left-1/2 transform -translate-x-1/2">
            <div className="relative">
              {/* Animated musical notes */}
              <div className="animate-float-1 absolute -left-8">♪</div>
              <div className="animate-float-2 absolute left-0">♫</div>
              <div className="animate-float-3 absolute left-8">♬</div>
            </div>
          </div>

          {/* Main 404 text */}
          <h1 className="text-6xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-500">
            404
          </h1>
          <h2 className="text-2xl font-semibold mb-4 text-gray-700 dark:text-gray-300">
            Oops! This page has gone off-key
          </h2>
        </div>

        <p className="text-gray-600 dark:text-gray-400 mb-8 max-w-md mx-auto">
          Looks like we hit a wrong note! The page you're looking for seems to
          have wandered off the music sheet.
        </p>

        {/* Return home button */}
        <Link
          href="/"
          className="inline-flex items-center px-6 py-3 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition-colors duration-200"
        >
          <span className="mr-2">🎵</span>
          Return to Homepage
        </Link>
      </div>

      {/* Add animation keyframes to the page */}
      <style jsx global>{`
        @keyframes float-1 {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }
        @keyframes float-2 {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-25px) rotate(-5deg); }
        }
        @keyframes float-3 {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(15deg); }
        }
        .animate-float-1 {
          animation: float-1 3s ease-in-out infinite;
          font-size: 2rem;
        }
        .animate-float-2 {
          animation: float-2 3.5s ease-in-out infinite;
          font-size: 2.5rem;
        }
        .animate-float-3 {
          animation: float-3 4s ease-in-out infinite;
          font-size: 2rem;
        }
      `}</style>
    </div>
  );
}
